import client from './api-client';

export const serviceGetTipoInforme = async (query) => {
    try {
        const response = await client.getSelect(`detalles?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetGestores = async (query) => {
    try {
        const response = await client.getSelect(`proveedores-rol?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetRequisitos = async (query) => {
    try {
        const response = await client.getSelect(`requisitos-gestion?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const serviceGetImplicados = async(query) => {
    try {
        
        const response = await client.getSelect(`caso/implicado/terceros?q=${query}`);      
        
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}
export const serviceGetSolicitudes = async(query) => {
    try {
        
        const response = await client.getSelect(`informe-profesional/solicitudes?q=${query}`);      
        
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}
export const serviceGestionarInforme = async (body) => {
    try {
        const response = await client.postSelect('informe-profesional/gestionar', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}
export const serviceGetDocumento = async(query) => {
    try {
        const response = await client.getDoc(`get-file?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}